/* eslint-disable */
import './modules/global';
import './modules/rest-comment';
import './modules/load-more-cpt-posts';
import { deffer_carousel } from './modules/img-defer';
import { initCarouselIndicators } from './modules/utils';
import Carousel from 'bootstrap/js/src/carousel';
import './modules/splide';
import {instant_defer} from "./modules/img-defer";
import {refreshCart} from "./modules/refreshCart";
import {AddToCart} from "./modules/cart";


window.addEventListener('load', () => {
    const carousels = document.querySelectorAll('.carousel');
    carousels && carousels.forEach(carousel => {
        new Carousel(carousel);
        initCarouselIndicators(carousel);
    });
    deffer_carousel();
    instant_defer();
    refreshCart('', {});
    new AddToCart();

    document.addEventListener('click', e => {
        if ( !e.target.closest('.btn-fullscreen') ) return;
        const closest_el = e.target.closest('.btn-fullscreen'),
            carousel_container = document.querySelector(closest_el.dataset.open),
            carousel = carousel_container.querySelector('.slide');
        carousel.classList.add('carousel');
        new Carousel(carousel);
        initCarouselIndicators(carousel);
        deffer_carousel();
    });

    document.querySelectorAll('.page-content iframe').forEach(element => {
        !element.parentElement.classList.contains('iframe-container') && element.parentElement.tagName === 'P' && element.parentElement.classList.add('iframe-container', 'embed-16by9');
    });
});

// sticky header

window.onscroll = function() {
    setTimeout(() => {
        if (document.documentElement.scrollTop > 200) {
            const stickyHeader = document.querySelector('.single-post__header_sticky');
            stickyHeader.classList.add('active');
        }else {
            const stickyHeader = document.querySelector('.single-post__header_sticky');
            stickyHeader.classList.remove('active');
        }
    }, 500);
};

function skriptaZaSliku() {


    var br_slika = document.querySelectorAll('.single-post__content.page-content p img').length
    console.log(br_slika)
    for(var x = 0; x < br_slika; x++) {
        var span_below = document.createElement('span')
        span_below.setAttribute('class', 'watermark')
        var text = document.querySelectorAll('.single-post__content.page-content p img')[x].getAttribute('title')
        span_below.innerText = text
        var old_html = document.querySelectorAll('.single-post__content.page-content p img')[x].parentElement.innerHTML
        var new_html = '<div class="img-wrap" style="position: relative;">' + old_html + span_below.outerHTML + '</div>'

        document.querySelectorAll('.single-post__content.page-content p img')[x].parentElement.innerHTML = new_html

    }

}
skriptaZaSliku();



// WEBPACK FOOTER //
// ./scripts/single-post.js